(ns app.front.view.group.admin.fees.group.group-events
  (:require [app.front.entities :as entities]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-fx
  ::create
  (fn [_ [_ fee-schedule-id group-titles]]
    {:comm/command {:command    :fee/create-fee-group
                    :method     :post
                    :data       {:fee-schedule-id fee-schedule-id
                                 :data            {:fee-group/titles group-titles}}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :fees/group-created}}}))


(rf/reg-event-fx
  ::edit
  (fn [_ [_ fee-group-id group-titles]]
    {:comm/command {:command    :fee/edit-fee-group
                    :method     :post
                    :data       {:fee-group-id fee-group-id
                                 :changes      {:fee-group/titles group-titles}}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :fees/group-edited}}}))


(rf/reg-event-fx
  ::delete
  (fn [_ [_ fee-group-id]]
    {:comm/command {:command    :fee/delete-fee-group
                    :method     :post
                    :data       {:fee-group-id fee-group-id}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :fees/group-deleted}}
     ;; Unselect this group from the draft fee template if it is in unsaved changes
     :dispatch     [:app.front.view.group.admin.fees.template.template-events/unselect-group fee-group-id]}))
